import { Suburb } from './suburb.model';
import { CommonResponse } from './commonresponsemodel';

export class AddressLocation {
    Address1: string;
    City:string;
    Suburb: Suburb;
    Latitude: string;
    Longitude: string;
}